import { CircularProgressBarCoreDriver } from './CircularProgressBarCore/CircularProgressBarCore.driver';
import { CircularProgressBarSize, CircularProgressBarSkin } from './index';

export interface CircularProgressBarDriver
  extends CircularProgressBarCoreDriver {
  isErrorIconShown: () => boolean;
  isSuccessIconShown: () => boolean;
  getSize: () => CircularProgressBarSize;
  hasSkin: (skinName: CircularProgressBarSkin) => boolean;
  getTooltipErrorMessage: () => string;
}
